import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EmpTariff } from '@pay/pricing-shared/data/tariffs.data';
import { ProgressStates } from '@widgets/save-button/save-button.component';
import { PriceListComputationStatus } from '../data/price-list.data';

export const PricingSubscriptionsActions = createActionGroup({
  source: 'Pricing Subscriptions',
  events: {
    'Select Business Partner': props<{ payload: string }>(),
    'Get Price List Computation Status': props<{ payload: string }>(),
    'Get Price List Computation Status Success': props<{ payload: PriceListComputationStatus }>(),
    'Get Price List Computation Status Error': emptyProps(),
    'Compute New Price List': emptyProps(),
    'Set Subscriptions': props<{ subscriptions: EmpTariff[] }>(),
    'Add Subscription': props<{ subscription: EmpTariff }>(),
    'Upsert Subscription': props<{ tariffId: string; subscription: EmpTariff }>(),
    'Update Subscription': props<{ tariffId: string; changes: Partial<EmpTariff> }>(),
    'Set Active Subscription': props<{ tariffId: string | null }>(),
    'Set Subscriptions Loading': props<{ loading: boolean }>(),
    'Update Subscriptions UI': props<{ saveButtonState: ProgressStates }>(),
    'Set Editing Subscription': props<{ subscription: EmpTariff | null }>(),
    'Reset Subscriptions': emptyProps(),
  },
});
